import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Checkbox from '@eig-builder/core-ui/Checkbox'
import CircularProgress from '@eig-builder/core-ui/CircularProgress'
import FormControlLabel from '@eig-builder/core-ui/FormControlLabel'

import { DataElementLocations } from '@eig-builder/core-utils/helpers/tagging-helper'

import { DowngradeAccountContext } from './context'

import Text from '@eig-builder/module-localization'

const ProgressWrapper = styled.div`
  text-align: center;
`

const RegisteredDomains = props => {
  const { domainsToKeep, setDomainsToKeep } = useContext(DowngradeAccountContext)

  const handleCheckbox = id => event => {
    const checked = event.target.checked
    let newList = [...domainsToKeep]

    if (checked) {
      newList.push(id)
    } else {
      newList = newList.filter(d => d !== id)
    }

    setDomainsToKeep(newList)
  }

  if (props.retrieving) {
    return (
      <ProgressWrapper>
        <CircularProgress centered />
        <Text message='modules.crm.components.account.downgradeAccount.loadingRegisteredDomains' />
      </ProgressWrapper>
    )
  }

  if (props.registeredDomains && props.registeredDomains.length > 0) {
    return (
      <>
        <Text message='modules.crm.components.account.downgradeAccount.registeredDomains' />
        <div className='mt-3'>
          {props.registeredDomains.map(domain => {
            return (
              <div key={domain.id}>
                <FormControlLabel
                  control={
                    <Checkbox
                      color='primary'
                      checked={domainsToKeep.includes(domain.id)}
                      onChange={handleCheckbox(domain.id)}
                      dataElementLocation={DataElementLocations.BODY}
                      dataElementLabel={`cst-account-downgrade--registered-domain-checkbox-${domain.id}`}
                      dataElementId={`cst-account-downgrade--registered-domain-checkbox-${domain.id}`}
                    />
                  }
                  label={domain.name}
                />
              </div>
            )
          })}
        </div>
      </>
    )
  }

  return <Text message='modules.crm.components.account.downgradeAccount.noRegisteredDomains' />
}

RegisteredDomains.propTypes = {
  retrieving: PropTypes.bool.isRequired,
  registeredDomains: PropTypes.array
}

export default RegisteredDomains
